import React, { useState, FunctionComponent } from 'react';

import { AssetsResponseObject } from '@api/v4/assets/assetTypes';

import AssetBoardCard from '../components/asset_board_card';
import AssetBoardCardThumbnailArea from '../components/asset_board_card_thumbnail_area';
import AssetBoardActionsOverlay from '../components/asset_board_actions_overlay';
import AssetBoardActions from '../components/asset_board_actions';
import AssetBoardCardDescription from '../components/asset_board_card_description';

import RemoveAssetModal from './remove_asset_modal';

interface AssetCardProps {
  asset: AssetsResponseObject;
  boardId: string;
  boardName: string;
}

type AssetCardComponentType = FunctionComponent<AssetCardProps>;

const AssetCard: AssetCardComponentType = ({ asset, boardId, boardName }): JSX.Element => {
  const [showRemoveAssetModal, setShowRemoveAssetModal] = React.useState(false);
  const [showOverlay, setShowOverlay] = useState(false);
  const [closeDropdown, setCloseDropdown] = useState(false);

  const handleShowRemoveModal = (): void => {
    setShowRemoveAssetModal(true);
    setCloseDropdown(true);
  };

  return (
    <>
      {showRemoveAssetModal && (
        <RemoveAssetModal
          boardName={boardName}
          boardId={boardId}
          assetId={asset.id}
          closeModal={(): void => setShowRemoveAssetModal(false)}
        />
      )}
      <AssetBoardCard className="asset-board-asset-card">
        <AssetBoardCardThumbnailArea setShowOverlay={setShowOverlay} resource={asset}>
          <AssetBoardActionsOverlay showOverlay={showOverlay} buttonText={t("View")} onClickHandler={(): WindowProxy | null => window.open(asset.attributes.best_link_for, "_blank")}>
            <AssetBoardActions
              closeDropdown={closeDropdown}
              handleShowRemoveModal={handleShowRemoveModal}
              updateCloseDropdown={(): void => setCloseDropdown(false)}
            />
          </AssetBoardActionsOverlay>
        </AssetBoardCardThumbnailArea>
        <AssetBoardCardDescription leftText={asset.attributes.name} rightText={asset.attributes.extension} pillStyling="file-type-pill" />
      </AssetBoardCard>
    </>
  );
};

export default AssetCard;
